export const TRANSFER_STATUS = {
  STATUS_WAITING: 0,
  STATUS_WORKING: 10,
  STATUS_ABORT: 5,
  STATUS_SUCCESS: 1,

  STATUS_UPLOAD: 11, // Data is being uploaded
  STATUS_ENC_UPLOAD: 15, // encrypting data pre-upload
  STATUS_UPLOAD_CANCELLED: 1001,

  STATUS_DOWNLOAD: 12, // Data is being downloaded.
  STATUS_DECRYPT_DOWNLOAD: 16, // Data downloaded is decrypting
  STATUS_PREPAREDOWNLOAD: 18, // indexeddb is prearing dl
  STATUS_DOWNLOAD_CANCELLED: 1002,

  STATUS_ERROR: 3000, // an error occurred
  STATUS_ERR_SIZE: 3020, // the file is too big
  STATUS_ERR_DISK_SPACE: 3021, // not enough local storage available to download the file
  STATUS_ERR_OPEN: 3010, // the file cannot be opened
  STATUS_ERR_NAME: 3500, // illegal file name
  STATUS_ERR_SHARE_KEY: 2000, // no share key
  STATUS_ERR_DATA_KEY: 2010, // missing data key
  STATUS_ERR_GENERIC: 7247, // Generic runtime error
};

export enum TransferQueueType {
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
}

export const VALID_UPLOAD_STATUS = [
  TRANSFER_STATUS.STATUS_WORKING,
  TRANSFER_STATUS.STATUS_UPLOAD,
  TRANSFER_STATUS.STATUS_ENC_UPLOAD,
];

export const VALID_DOWNLOAD_STATUS = [
  TRANSFER_STATUS.STATUS_WORKING,
  TRANSFER_STATUS.STATUS_DOWNLOAD,
  TRANSFER_STATUS.STATUS_DECRYPT_DOWNLOAD,
  TRANSFER_STATUS.STATUS_PREPAREDOWNLOAD,
];

export const PREVIEW_UNAVAILABLE_STATUSES: number[] = [
  TRANSFER_STATUS.STATUS_ERR_SIZE,
  TRANSFER_STATUS.STATUS_ERR_DISK_SPACE,
  TRANSFER_STATUS.STATUS_ERR_OPEN,
];

export const COMPAT_DOWNLOAD_THRESHOLD = 100 * 1024 * 1024; //100 MB
